export const generateUniqueId = (prefix: string): string => {
  if (typeof globalThis !== 'undefined' && 'crypto' in globalThis) {
    const cryptoObj = (globalThis as { crypto?: Crypto }).crypto;
    if (cryptoObj && 'randomUUID' in cryptoObj && typeof cryptoObj.randomUUID === 'function') {
      return `${prefix}-${cryptoObj.randomUUID()}`;
    }
  }

  const random = Math.random().toString(36).slice(2, 8);
  return `${prefix}-${Date.now()}-${random}`;
};

let sourceCounter = 0;
let targetCounter = 0;

export const generateElementId = (prefix: string): string => {
  return generateUniqueId(`el-${prefix}`);
};

export const generateSourceId = (): string => {
  sourceCounter += 1;
  return generateUniqueId(`src${sourceCounter}`);
};

export const generateTargetId = (): string => {
  targetCounter += 1;
  return generateUniqueId(`trg${targetCounter}`);
};
